// CommitChart.js

import numeral from 'numeral'
import {Doughnut} from 'vue-chartjs/dist/vue-chartjs'

export default {
  extends: Doughnut,
  name: 'food-pie',
  props: {
    fat: {
      type: Number,
      default: 40
    },
    carbs: {
      type: Number,
      default: 60
    },
    protein: {
      type: Number,
      default: 50
    },
    calories: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: "kcal"
    }
  },
  watch: {
    'fat': function () {
      this.render();
    },
    'protein': function () {
      this.render();
    },
    'carbs': function () {
      this.render();
    }
  },
  mounted() {
    let self = this;
    self.addPlugin({
      id: 'pieLabel',
      beforeDraw: function (chart) {
        const width = chart.chart.width, height = chart.chart.height, ctx = self.$refs.canvas.getContext("2d");
        ctx.restore();
        const fontSize = (height / 114).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "#333";
        const number = numeral(self.calories.toFixed(2));
        const text = self.labelText,
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    });
    self.render();
  },
  computed: {
    labelText() {
      let number = 0;
      if (this.unit === "kcal") {
        number = this.calories.toFixed(2)
      } else {
        //Add together the gram values
        number = (this.fat + this.carbs + this.protein).toFixed(2);
      }
      number = numeral(number);
      return `${number.format('0,0')}${this.unit}`
    }
  },
  methods: {
    render() {
      let self = this;
      self.renderChart({
        labels: [
          this.$t('message.nutrientFat'),
          this.$t('message.nutrientCarbohydrate'),
          this.$t('message.nutrientProtein')
        ],
        datasets: [
          {
            backgroundColor: [
              'rgb(192, 77, 216)',
              'rgb(78, 216, 218)',
              'rgb(224, 105, 80)'
            ],
            data: [this.fat, this.carbs, this.protein]
          }
        ]
      }, {
        legend: false,
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        percentageInnerCutout: 24,
        hover: {
          mode: null
        },
        tooltips: {
          enabled: false
        },
        plugins: {
          pieLabel: true
        }
      });
    },
  }

}



// WEBPACK FOOTER //
// ./src/components/FoodDiary/Graphs/Pie/pie.js